


try {
  const element = document.getElementById('t4s-top-bar-main');
  function toggleVisibility() {
    if (window.scrollY > 50) {
      element.style.display = 'none';
    }
    else {
      element.style.display = 'block';
    }
  }
  if (element) window.addEventListener('scroll', toggleVisibility);
} catch (error) {
  console.log(error)
}


/** 
 * 触发 Dialog 的按钮的事件
 */
(function () {
  const dialogBtnEls = document.querySelectorAll(".moft-show-dialog[data-moft-show-dialog]");
  if (dialogBtnEls.length <= 0) return;
  const overlayEl = document.querySelector(".t4s-close-overlay");
  const htmlEl = document.querySelector("html");
  overlayEl.addEventListener("click", function (e) {
    const dialogEl = document.querySelector(".moft-dialog--opened");
    dialogEl.classList.remove("moft-dialog--opened");
    overlayEl.classList.remove("is--visible");
    htmlEl.classList.remove("t4s-lock-scroll");
  });
  for (let i = 0; i < dialogBtnEls.length; i++) {
    const dialogBtnEl = dialogBtnEls[i];
    dialogBtnEl.addEventListener("click", function (e) {
      const current = dialogBtnEl;
      const id = current.getAttribute("data-dialog-id");
      const dialogEl = document.getElementById(`moft-dialog__${id}`);
      dialogEl.classList.add("moft-dialog--opened");
      if (window.innerWidth <= 768) htmlEl.classList.add("t4s-lock-scroll");
      overlayEl.classList.add("is--visible");
      $(window).trigger('resize');
    })
  }
})();


/** 
 * Dialog 关闭按钮的事件
 */
(function () {
  const dialogEls = document.querySelectorAll(".moft-dialog");
  if (dialogEls.length <= 0) return;
  const overlayEl = document.querySelector(".t4s-close-overlay");
  const htmlEl = document.querySelector("html");
  for (let i = 0; i < dialogEls.length; i++) {
    const dialogEl = dialogEls[i];
    const closeBtnEl = dialogEl.querySelector(".moft-dialog__close");
    closeBtnEl.addEventListener("click", function () {
      dialogEl.classList.remove("moft-dialog--opened");
      overlayEl.classList.remove("is--visible");
      htmlEl.classList.remove("t4s-lock-scroll");
    });
  }
})();


/**
 * 解决 Dialog 与 侧边 Cart 冲突
 */
(function () {
  const dialogEl = document.querySelector(".moft-dialog");
  if (!dialogEl) return;
  // 目标元素
  const target = document.querySelector('html');
  // 创建一个MutationObserver实例
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // 监听到 class 属性发生变化，执行相应的操作
        if (target.classList.contains("is--opend-drawer")) {
          const dialogEls = document.querySelectorAll(".moft-dialog");
          for (let el of dialogEls) el.classList.remove("moft-dialog--opened"); /// 关闭 Dialog
        }
      }
    });
  });
  // 配置观察选项
  const config = { attributes: true };
  // 传入目标节点和观察选项开始观察
  observer.observe(target, config);
})();
